import TPBPageHeading from './TPBPageHeading.component';

export default TPBPageHeading;
